module.exports = {"Logout6":{"daobanList":[{"title":"1:企业破产（强制清算）信息查询一件事","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"破产（强制清算）案件受理裁定书（原件电子版）","state":"必要"},{"name":"指定管理人（清算组）决定书（原件电子版）","state":"必要"},{"name":"经办人身份证","state":"必要"},{"name":"授权委托书","state":"必要"},{"name":"更名证明文件（有曾用名或分支机构需提供）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdl-6.json
// module id = 1265
// module chunks = 0